import { render, staticRenderFns } from "./ViewRentTariffsDetails.vue?vue&type=template&id=f8841a2a&scoped=true&lang=pug&"
import script from "./ViewRentTariffsDetails.vue?vue&type=script&lang=js&"
export * from "./ViewRentTariffsDetails.vue?vue&type=script&lang=js&"
import style0 from "./ViewRentTariffsDetails.vue?vue&type=style&index=0&id=f8841a2a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8841a2a",
  null
  
)

export default component.exports